/*
 * views/spaView.js
 * Spa View
 */

define( 'app/views/userView',[
    'lib/event',
    'app/views/commonViewHelper',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/breadcrumbs',
    'hbs!app/views/templates/content',
    'hbs!app/views/templates/userCreateUserForm',
    'hbs!app/views/templates/userChangePasswordForm',
    'hbs!app/views/templates/userResetPasswordForm',
    'hbs!app/views/templates/userLoginForm',
    'hbs!app/views/templates/userProfileForm',
    'bootstrap'
], function( Event, commonViewHelper, navbarTpl, breadcrumbsTpl, contentTpl, userCreateUserForm, userChangePasswordForm, userResetPasswordForm, userLoginForm, userProfileForm) {
    var userView = {
        app:app,
        event:$.extend({}, Event),
        module:"user"
    };
      _.invert = function(obj) {
        var result = {};
        var keys = _.keys(obj);
        for (var i = 0, length = keys.length; i < length; i++) {
          result[obj[keys[i]]] = keys[i];
        }
        return result;
      };

    userView.event.listen('requestCreateUser', userView, function (e, type) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.user = [
            {name:app.localization.general.login.profileLabel, url:"#/profile"},
            {name:app.localization.general.login.newUserButtonLabel, url:"#/profile/create", last:true}
        ];
        var createUserFormHbsParams = {
            Localization:app.localization,
            languages:app.data.languageNames,
            language:app.language,
            Customization:app.customization,
            type: type
        }
        
        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        $('#nav').html(navbarTpl({
            Customization:app.customization,
            Localization:app.localization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service
        }));

        $('#content').addClass('userCreateUserForm').html(userCreateUserForm(createUserFormHbsParams));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.user
        }))

        if(app.data.userLoggedIn) $('.userCreateUserForm').addClass('userCreateUserFormLoggedIn')
        commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.prepCreateUserForm(type);
    });

    userView.event.listen('requestAddGroupMember', userView, function (e) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.user = [
            {name:app.localization.general.login.profileLabel, url:"#/profile"},
            {name:app.localization.general.login.addGroupMember, url:"#/profile/addmember", last:true}
        ];

        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        $('#nav').html(navbarTpl({
            Customization:app.customization,
            Localization:app.localization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service
        }));
        $('#content').addClass('userCreateUserForm').html(userCreateUserForm({
            Localization:app.localization,
            languages:app.data.languageNames,
            language:app.language,
            Customization:app.customization
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.user
        }))
      
        if(app.data.userLoggedIn) $('.userCreateUserForm').addClass('userCreateUserFormLoggedIn')
        commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.prepCreateUserForm();
    });

    userView.event.listen('requestChangePassword', userView, function (e, eventName, oldPassword, conflictsRemoved) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.user = [
            {name:app.localization.general.login.profileLabel, url:"#/profile"},
            {name:app.localization.general.login.changePassword.title, url:"#/profile/change", last:true}
        ];

        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        if (eventName!='updateLoginResult') {
            $('#nav').html(navbarTpl({
                Customization:app.customization,
                Localization:app.localization,
                services:app.data.serviceTypes,
                languages:app.data.languageNames,
                siteName:app.localization.siteName,
                backLink:app.customization.serverURL
            }));
            $('#main').html(contentTpl({
                Localization:app.localization,
                services:app.data.serviceTypes,
                bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
                siteName:app.localization.siteName,
                backLink:app.customization.serverURL,
                service:service
            }));
            $('#content').addClass('userChangePasswordForm').html(userChangePasswordForm({
                Localization:app.localization,
                Customization:app.customization,
                ShowCreatePassword: app.data.folioLoginHasPassword == "N" && app.data.RestrictedFolio,
                RestrictedUserHasPassword: app.data.folioLoginHasPassword == "Y" && app.data.RestrictedFolio,
                RestrictedFolio: app.data.RestrictedFolio,
                MinPasswordStrength: app.data.minPasswordStrength
            }));
            $('#breadcrumbs').html(breadcrumbsTpl({
                'breadCrumbs':app.data.breadCrumbs.user
            }))
            commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        } else {
            $('#userCreateUserForm > div:first-of-type').addClass('userChangePasswordForm').html(userChangePasswordForm({
                Localization:app.localization,
                Customization:app.customization
            }));
            $('#userCreateUserForm button').off('click')
            $('#userCreateUserForm').attr('id','userChangePasswordForm')
        }
        commonViewHelper.showMessages();
        commonViewHelper.prepChangePasswordForm(eventName,oldPassword,conflictsRemoved);
    });

    userView.event.listen('requestResetPasswordChange', userView, function (e, email, passwordGuid) {
            app.data.breadCrumbs = app.data.breadCrumbs || {};
            app.data.breadCrumbs.user = [
                {name:app.localization.general.login.passwordReset.titleForForm, url:"#/profile/resetpassword", last:true}
            ];

            var service = {
                id : "profile",
                icon : "ok",
                name : app.localization.general.serviceButtonLabel
            };
    
            $('#nav').html(navbarTpl({
                Customization:app.customization,
                Localization:app.localization,
                services:app.data.serviceTypes,
                languages:app.data.languageNames,
                siteName:app.localization.siteName,
                backLink:app.customization.serverURL
            }));
            $('#main').html(contentTpl({
                Localization:app.localization,
                services:app.data.serviceTypes,
                bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
                siteName:app.localization.siteName,
                backLink:app.customization.serverURL,
                service:service
            }));
            $('#content').addClass('userChangePasswordForm').html(userChangePasswordForm({
                Localization:app.localization,
                Customization:app.customization,
                ShowCreatePassword: app.data.folioLoginHasPassword == "N" && app.data.RestrictedFolio,
                RestrictedUserHasPassword: app.data.folioLoginHasPassword == "Y" && app.data.RestrictedFolio,
                RestrictedFolio: app.data.RestrictedFolio
            }));
            $('#breadcrumbs').html(breadcrumbsTpl({
                'breadCrumbs':app.data.breadCrumbs.user
            }))
            
            commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);

            commonViewHelper.prepResetPasswordSubmit(email, passwordGuid);
    });

    userView.event.listen('requestResetPassword', userView, function (e, emailaddress) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.user = [
            {name:app.localization.general.login.profileLabel, url:"#/profile"},
            {name:app.localization.general.login.passwordReset.title, url:"#/profile/reset", last:true}
        ];

        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        $('#nav').html(navbarTpl({
            Customization:app.customization,
            Localization:app.localization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service,
            emailaddress:emailaddress
        }));
        $('#content').addClass('userResetPasswordForm').html(userResetPasswordForm({
            Localization:app.localization,
            Customization:app.customization
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.user
        }))
        commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.prepResetPasswordForm();
    });

    userView.event.listen('requestUserLogin', userView, function (e, email, password, user, group, mode,urlParameter, contactLogTypes) {

        
        var module = app.data.loginNextURL && app.data.loginNextURL[0] || 'nomodule'
          , action = app.data.loginNextURL && app.data.loginNextURL[1] || 'noaction'
          , contexts = _.keys(app.localization.newUser.context)
          , contextModules = _.filter(contexts,function(x){return x.match(new RegExp("(^"+module+"/)|(^\\*/)","i"))})
          , contextActions = _.filter(contextModules,function(x){return x.match(new RegExp("(^[^/]+/"+action+"$)|(^[^/]+/\\*$)","i"))})
          , contextAction = _.sortBy(contextActions,function(x){return -x.length})
        contextAction = contextAction[0] || "*/*"
        if (mode=='signon' && app.localization.newUser.context['profile/signon']) { contextAction = 'profile/signon' };
     
        app.localization.newUser.activeContext = app.localization.newUser.context[contextAction];
      
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.user = [
            {name:
                app.data.userLoggedIn
                    ? app.localization.general.login.profileLabel
                    : app.localization.newUser.activeContext.breadcrumb, url:"#/profile", last:true}
        ];
        if(contextAction == '*/*') { 
            app.data.loginNextURL = ['profile','details']
        };
        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        var userLoginFormHbsParams = {
            Localization:app.localization,
            Customization:app.customization,
            useIntegratedLogin : !!app.customization.login.useIntegratedLogin && !app.customization.disableAccountCreation,
            email: email,
            password: password,
            user: user,
            group: group,
            mode: mode,
            hasGroupMembers: group && group.GroupMember && $.isArray(group.GroupMember),
            anyFutureBookings: (app.data.pmsBookingFuture && app.data.pmsBookingFuture.length > 0) || (app.data.spaBookingFuture && app.data.spaBookingFuture.length > 0) || (app.data.golfBookingFuture && app.data.golfBookingFuture.length > 0),
            anyPastBookings: (app.data.pmsBookingPast && app.data.pmsBookingPast.length > 0) || (app.data.spaBookingPast && app.data.spaBookingPast.length > 0) || (app.data.golfBookingPast && app.data.golfBookingPast.length > 0),
            userLoggedIn: app.data.userLoggedIn,
            userLoggedInAndNotSigningOn: app.data.userLoggedIn && mode!='signon',
            languages:app.data.languageNames,
            language:app.language,
            CustomerEmail: app.data.CustomerEmail,
            ShowCreatePassword: app.data.folioLoginHasPassword == "N" && app.data.RestrictedFolio,
            RestrictedUserHasPassword: app.data.folioLoginHasPassword == "Y" && app.data.RestrictedFolio,
            RestrictedFolio: app.data.RestrictedFolio,
            MinPasswordStrength: app.data.minPasswordStrength
        };

        userLoginFormHbsParams.ContactLogTypes = _.map(contactLogTypes, function(contactLog){
            //check for show
            //add localization and description
            var contactLogType = contactLog.LogType
            var logCustomization = app.customization.visibleContactLogs[contactLogType];
            var logLocalization = app.localization.visibleContactLogs

            var tag = logCustomization && logCustomization.tag ? logCustomization.tag : 'input';
            var type = logCustomization && logCustomization.type ? logCustomization.type : 'text';
            var label = logLocalization && logLocalization.labels[contactLogType] ? logLocalization.labels[contactLogType] : contactLog.LogType;
            var description =logLocalization && logLocalization.descriptions[contactLogType] ? logLocalization.descriptions[contactLogType] : '';
            return _.extend(contactLog, {CanNotCreate: contactLog.GuestOption === 'R', Type: type, Label: label, Description: description, Visible: logCustomization && (contactLog.GuestOption === 'W'), Tag: tag})
        });
        userLoginFormHbsParams.VisibleContactLogs = app.customization.visibleContactLogs && Object.keys(app.customization.visibleContactLogs).length;

        $('#nav').html(navbarTpl({
            Customization:app.customization,
            Localization:app.localization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service
        }));
        $('#content').addClass('userLoginForm').html(userLoginForm(userLoginFormHbsParams));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.user
        }))
        if( mode == 'folio'){
            $('body').addClass('content-folio')
        } else {
            $('body').removeClass('content-folio')
        }
        commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.prepUserLoginForm(mode,urlParameter);
    });

    userView.event.listen('requestUserProfile', userView, function (e, userData, type, userId, contactLogsArr, proceedToCheckout) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.user = [
            {name:app.localization.general.login.profileLabel, url:"#/profile"},
            {name:app.localization.general.login.editProfileLabel, url:"#/profile/details", last:true}
        ];
        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        var params = {
            Localization:app.localization,
            Customization:app.customization,
            languages:app.data.languageNames,
            language:app.language,
            userLoggedIn: app.data.userLoggedIn,
            CustomerEmail: app.data.CustomerEmail,
        };
        
        $.extend(params,userData, {isEditable:(userData.CustomerId==app.data.CustomerId)||(userData.CanEdit=='Y')});
        params.userLanguage = _.invert(app.customization.submitLanguage)[userData.Language] || "";
        params.CustomerEmail = params.CustomerEmail.toLowerCase();
        var combinedContactLogs = [];
        if(userData.ContactLogs) {
            var afterFormatting = commonViewHelper.formatContactLogNotes(userData.ContactLogs.ContactLog);
            combinedContactLogs = commonViewHelper.combineContactLogsByName(afterFormatting);
        }
        var logsToConcat = _.filter(contactLogsArr, function(contactLog){
            //if this type doesnt already exist in combined logs
            return !_.find(combinedContactLogs, function(log){
                        return log.LogType === contactLog.LogType
                    });
        });
        
        params.ContactLogs = _.map(combinedContactLogs.concat(logsToConcat), function(contactLog){
            var contactLogType = contactLog.LogType
            var logCustomization = app.customization.visibleContactLogs[contactLogType];
            var logLocalization = app.localization.visibleContactLogs
            
            var tag = logCustomization && logCustomization.tag ? logCustomization.tag : 'input';
            var type = logCustomization && logCustomization.type ? logCustomization.type : 'text';
            var label = (logLocalization && logLocalization.labels[contactLogType]) ? logLocalization.labels[contactLogType] : contactLog.LogType;
            var description =(logLocalization && logLocalization.descriptions[contactLogType]) ? logLocalization.descriptions[contactLogType] : '';

            return _.extend(contactLog, {CanEdit: contactLog.GuestOption === 'M', CanNotCreate: contactLog.GuestOption === 'R', Type: type, Label: label, Description: description, Visible: logCustomization, Tag:tag})
        });
        params.VisibleContactLogs = app.customization.visibleContactLogs && Object.keys(app.customization.visibleContactLogs).length;

        $('#nav').html(navbarTpl({
            Customization:app.customization,
            Localization:app.localization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service
        }));
        $('#content').addClass('userProfileForm').html(userProfileForm(params));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.user
        }))
        commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.prepUserProfileForm(type,userId, proceedToCheckout);
        commonViewHelper.cardOnFile(userData,userId);
    });

    userView.event.listen('updateLoginResult', userView, function (e, result) {
        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        commonViewHelper.updateLoginResult(result,service);
        if (!!result) {
            commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        }
        commonViewHelper.showMessages();
    })

    userView.event.listen('updateDiningLoginResult', userView, function (e, result, redirect) {
        if (result&&redirect=='redirect') {
            app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
            app.data.loginNextURL = undefined;
            return;
        }

        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.diningView.module
        }));
        commonViewHelper.updateDiningLoginResult(result,service,redirect);
        if (!!result) {
            $('#nav').html(navbarTpl({
                Customization:app.customization,
                Localization:app.localization,
                services:app.data.serviceTypes,
                languages:app.data.languageNames,
                siteName:app.localization.siteName,
                backLink:app.customization.serverURL
            }));
            commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        }
        commonViewHelper.showMessages();
    })

    userView.event.listen('loginResetPasswordCustomer', userView, function (e, result, error) {
        commonViewHelper.loginResetPasswordCustomer(result, error);
    })
    userView.event.listen('folioEvent', userView, function ( e,success, result) {
        commonViewHelper.authenticatefolioresult(success, result);
    })
    userView.event.listen('renderLoginVue', userView, function (e, route) {
        var service = {
            id : "profile",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };


        // TODO: fix breadcrumbs for login page
        var breadcrumbMap = {
            login: 'Login',
            create: 'Create Account',
            guest: 'Create Guest Account',
            splash: 'Splash Page'
        }
        if(app.data.breadCrumbs){
            app.data.breadCrumbs.user = (route=== 'login' || route=== 'splash') ? [{name:breadcrumbMap[route], url:route === 'splash'? "#/profile/" : "#/profile/"+route, route: route}]  : [{name:breadcrumbMap['login'], url: "#/profile/login", route: 'login'}, {name:breadcrumbMap[route], url:route === 'splash'? "#/profile/" : "#/profile/"+route, route: route}]
        } 
        if(app.data.vueLoginAppRef) {
            app.data.vueLoginAppRef.$store.commit('setCurrentRoute',{currentRoute: route})
        }
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));

        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.spaBooking.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service
        }));

        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs': app.data.breadCrumbs.user
        }))
        
        commonViewHelper.updateNavBar(service,app.language,!!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        
        $('body').removeClass (function (index, css) {
            return (css.match (/(^|\s)content-\S+/g) || []).join(' ');
        }).addClass('content-login-vue-tpl');

        $('body #content').empty().append('<div class="vue-login-container"><div id="login-vue-app" /></div>');
        
        require(['loginVueApp/login-vue-app'], function (loginVue) {
            if(app.data.vueLoginAppRef) app.data.vueLoginAppRef.$destroy();
            loginVue({route:route});
            $('#progressIndicator').modal('hide');
        });
    })

    return window.app.views.userView = userView;

});

